export default __webpack_public_path__ + "a9bb885763544b5659f945bbd1deca9e.png";